var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t    .box-download-icon-st0{fill:currentColor;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "box-download-icon-st0",
    d: "M11.3182 8.84002H9.17855V6.32278H6.74521V8.84002H4.60556L7.96188 12.1963L11.3182 8.84002ZM15.1276 2.32037L13.9613 0.910713C13.7348 0.625426 13.3907 0.449219 12.9964 0.449219H2.9274C2.53303 0.449219 2.18901 0.625426 1.95406 0.910713L0.796133 2.32037C0.5528 2.60566 0.410156 2.98324 0.410156 3.386V13.8745C0.410156 14.7975 1.16533 15.5527 2.08832 15.5527H13.8354C14.7584 15.5527 15.5136 14.7975 15.5136 13.8745V3.386C15.5136 2.98324 15.371 2.60566 15.1276 2.32037ZM3.12878 2.12738H12.795L13.4746 2.94129H2.45751L3.12878 2.12738ZM13.8354 13.8745H2.08832V4.64462H13.8354V13.8745Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDownloadIcon);
export default __webpack_public_path__ + "static/media/box_download-icon.8bd5ef2f969bb65fd773f7a82694d930.svg";
export { ForwardRef as ReactComponent };